import { render, staticRenderFns } from "./SContent.vue?vue&type=template&id=5813e229&"
import script from "./SContent.vue?vue&type=script&lang=js&"
export * from "./SContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports